var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{ref:"selectOption",staticClass:"select-dd--list__items",style:(`margin-top: ${_vm.option_h}px`),on:{"click":function($event){return _vm.getSelected(_vm.value)}}},[_c('span',{ref:"selectData"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }